<div class="row" *ngIf="w">
  <div class="col-lg-3">
    <div>
      <h3>Widget Size</h3>
      <select class="form-select" [(ngModel)]="w.size">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group">
      <h3>Valid Period</h3>
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <h3>Refresh (Seconds)</h3>
      <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"/>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="disableTemplate" [(ngModel)]="w.disableTemplate">
        <label class="form-check-label" for="disableTemplate">Disable Template <br/><small>only value shown</small></label>
      </div>
    </div>
  </div>
</div>
<div class="row mt-2" *ngIf="w && w.timeSeriesList.length > 0">
  <div class="col-lg-4">
    <div class="form-group input-group-sm">
      <label>Select Time Series </label>
      <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="w.timeSeriesList[0]" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
      <!--<app-time-series-select [timeSeriesDetail]="w.timeSeriesList[0]" [enableTagMatch]="true"></app-time-series-select>-->
    </div>
    <div class="form-group" *ngIf="w && w.timeSeriesList && w.timeSeriesList[0]">
      <app-transform-editor [transforms]="w.timeSeriesList[0].transforms"></app-transform-editor>
    </div>
  </div>
  <div class="col-lg-8">
    <tabset #editorTabs>
      <tab heading="HTML">
        <div class="d-flex justify-content-end py-1 mb-1 border-bottom">
          <button class="btn btn-sm btn-outline-secondary" (click)="formatHtml()" title="Format HTML (Ctrl+Shift+F)">
            <i class="bi bi-code-slash"></i> Format HTML <small class="text-muted ms-1">Ctrl+Shift+F</small>
          </button>
        </div>
        <ngx-monaco-editor
          [(ngModel)]="w.html"
          [options]="{ language: 'html', theme: 'vs', readOnly: false, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
          (onInit)="onHtmlEditorInit($event)"
          style="display:block; height: 350px; width:100%; overflow: auto;">
        </ngx-monaco-editor>
      </tab>
      <tab heading="Templates">
        <!-- Gallery view -->
        <div *ngIf="!selectedTemplate">
          <div class="d-flex align-items-center gap-2 pt-2 px-2 pb-1 border-bottom">
            <div class="btn-group btn-group-sm" role="group">
              <button type="button" class="btn" [ngClass]="templateTypeFilter === 0 ? 'btn-primary' : 'btn-outline-secondary'" (click)="templateTypeFilter = 0">Free Text</button>
              <button type="button" class="btn" [ngClass]="templateTypeFilter === 1 ? 'btn-info' : 'btn-outline-secondary'" (click)="templateTypeFilter = 1">Multi Text</button>
            </div>
          </div>
          <div class="row row-cols-2 row-cols-lg-3 g-3 p-2">
          <div *ngIf="templatesLoading" class="col-12 text-center py-4">
            <div class="spinner-border spinner-border-sm me-2"></div> Loading templates...
          </div>
          <div *ngIf="!templatesLoading && filteredTemplates.length === 0" class="col-12 text-muted py-4 text-center">
            No templates available. Add some via Administration &rsaquo; Widget Templates.
          </div>
          <div class="col" *ngFor="let t of filteredTemplates">
            <div class="card template-card h-100" (click)="viewTemplate(t)">
              <img *ngIf="t.hasPreviewImage" [src]="getPreviewImageUrl(t.id)" class="card-img-top template-preview" [alt]="t.name">
              <div *ngIf="!t.hasPreviewImage" class="card-img-top template-preview d-flex align-items-center justify-content-center bg-light text-muted">
                <i class="bi bi-file-code fs-2"></i>
              </div>
              <div class="card-body p-2">
                <h6 class="card-title mb-1">{{t.name}}</h6>
                <p class="card-text text-muted small mb-0">{{t.description}}</p>
              </div>
              <div class="card-footer p-2">
                <button class="btn btn-sm btn-outline-secondary w-100" (click)="$event.stopPropagation(); viewTemplate(t)">
                  <i class="bi bi-eye"></i> View Template
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- Detail view -->
        <div *ngIf="selectedTemplate" class="p-2">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <button class="btn btn-sm btn-outline-secondary" (click)="closeTemplateDetail()">
              <i class="bi bi-arrow-left"></i> Back to Gallery
            </button>
            <button class="btn btn-sm btn-primary" (click)="applyTemplate(selectedTemplate)">
              <i class="bi bi-check2"></i> Use This Template
            </button>
          </div>
          <h5 class="mb-1">{{selectedTemplate.name}}</h5>
          <p class="text-muted small mb-3">{{selectedTemplate.description}}</p>
          <div class="row g-3">
            <div class="col-md-5">
              <img *ngIf="selectedTemplate.hasPreviewImage" [src]="getPreviewImageUrl(selectedTemplate.id)" class="img-fluid rounded border w-100 template-detail-preview" [alt]="selectedTemplate.name">
              <div *ngIf="!selectedTemplate.hasPreviewImage" class="rounded border w-100 template-detail-preview d-flex align-items-center justify-content-center bg-light text-muted">
                <i class="bi bi-file-code fs-1"></i>
              </div>
            </div>
            <div class="col-md-7">
              <pre class="template-code-preview border rounded p-2 mb-0" [textContent]="selectedTemplate.html"></pre>
            </div>
          </div>
        </div>
      </tab>
      <tab heading="Help">
        <div class="alert alert-primary">
          <div>
            You can dynamically change the contents of the widget based on the latest value supplied.
            The widget uses <a href="https://handlebarsjs.com/" target="_blank">Handlebars</a> formatting so you can loop through data.
          </div>
          <ngx-monaco-editor
            [(ngModel)]="example"
            [options]="{ language: 'html', theme: 'vs', readOnly: true, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
            style="display:block; height: 250px; width:100%; overflow: auto;">
          </ngx-monaco-editor>
        </div>
      </tab>
    </tabset>
  </div>
</div>

<!-- Preview section -->
<div class="row mt-3" *ngIf="w && w.timeSeriesList.length > 0">
  <div class="col-12">
    <div class="d-flex align-items-center gap-2 mb-2">
      <h5 class="mb-0">Preview</h5>
      <button class="btn btn-sm btn-outline-secondary" (click)="refreshPreview()" title="Re-render the template without fetching new data">
        <i class="bi bi-arrow-clockwise"></i> Refresh Preview
      </button>
      <button class="btn btn-sm btn-outline-theme" (click)="loadPreviewData()"
        [disabled]="isLoadingPreview || !w.timeSeriesList[0]?.uri"
        title="Fetch live data from the server and render the template">
        <span *ngIf="isLoadingPreview" class="spinner-border spinner-border-sm me-1"></span>
        <i *ngIf="!isLoadingPreview" class="bi bi-cloud-download"></i>
        Load Live Data
      </button>
      <small *ngIf="!w.timeSeriesList[0]?.uri" class="text-muted">Set a time series URI to enable live data loading</small>
    </div>
    <div class="preview-pane border rounded p-3" [innerHTML]="previewHtml | safe:'html'">
    </div>
  </div>
</div>
